import { createContext } from 'react';
export const CheckListContext = createContext(null);